/* eslint-disable max-len */
import Constants from '../constants';
import Utils from '../utils';

export default class SessionInfo {
    context = {
        device: '',
        os: '',
        page_type: '',
        geoloc: '',
        geoinfo: '',
        trafficSource: '',
        product: {
            url: '',
            product_id: '',
            name: '',
            price: 0,
            variant: '',
            price_currency_code: '',
            availability: '',
            category: '',
            description: '',
            brand: '',
        },
        cart: {},
        transaction: null,
        customer: {
            postal_code: '',
            geoloc: '',
            email: null,
            marketing_permission: false,
            first_name: '',
            last_name: '',
            customer_reference: '',
            birth_date: '',
        },
        categories: '',
        custom: {},
        href: document.location.href,
        hostname: document.location.href.replace(/\?.*/, ''),
        campaigns: {},
    };

    sessionData = {};

    constructor(wioCustom) {
        this.core = wioCustom;
    }

    onDataLayerPush = function () {
        console.log(arguments)
    }

    loadContext = () => {
        if (window.dataLayer && window.dataLayer.push && !window.dataLayer.pushprev) {
            window.dataLayer.pushprev = window.dataLayer.push;
            window.dataLayer.push = function () {
                window.dataLayer.pushprev.apply(this, arguments);
                WIO.sessionInfo.onDataLayerPush.apply(this, arguments)
            }
        }
        const contextBlock = document.getElementById('cibler_context');
        const contextval = contextBlock ? contextBlock.innerHTML : null;
        if (contextval) {
            try {
                this.context = Object.assign(this.context, JSON.parse(atob(contextval)));
            } catch (e) {
                try {
                    this.context = Object.assign(this.context, JSON.parse(contextval));
                } catch (ev) {
                }
            }
        }

        this.context.device = this.device();
        this.context.os = this.getOS();
        this.context.geoloc = this.geolocation();
        this.context.geoinfo = this.geoInfo();
        this.context.source = this.source();
        this.context.product = {...this.product(), ...this.context.product};
        this.context.cart = {...this.cart(), ...this.context.cart};
        this.context.transaction = {...this.transaction(), ...this.context.transaction};
        this.context.categories = {...this.categories(), ...this.context.categories};
        this.loadSessionData();
        this.loadCustomContext();

        if (!this.context.auth_status) {
            this.context.auth_status = this.context.customer && (
                this.context.customer.customer_reference || this.context.customer.customerReference
            ) ? 'ok' : 'anon';
        }
    };

    addSessionData = (name, data) => {
        if (this.context.sessionData[name] !== data) {
            this.context.sessionData[name] = data;
            sessionStorage.setItem(Constants.sessionDataKey, JSON.stringify(this.context.sessionData));
        }
    };

    loadSessionData = () => {
        this.context.sessionData = {};
        const str = (sessionStorage.getItem(Constants.sessionDataKey));
        if (Utils.isStringJson(str)) {
            this.context.sessionData = JSON.parse(str);
        }
    };

    loadClientContext = () => {
        if (window.ciblerContext)
            this.context = {...this.context, ...window.ciblerContext}
    }

    loadCustomContext = () => {
        this.loadClientContext();
        this.context.geoloc = Utils.tryFunction(this.core.geolocation, [this]) || this.context.geoloc;
        this.context.page_type = Utils.tryFunction(this.core.getPageType, [this]) || this.context.page_type;
        this.context.geoinfo = Utils.tryFunction(this.core.geoInfo, [this]) || this.context.geoinfo;
        this.context.product = Utils.tryFunction(this.core.getProductData, [this]) || this.context.product;
        this.context.customer = Utils.tryFunction(this.core.getCustomer, [this]) || this.context.customer;
        this.context.cart = Utils.tryFunction(this.core.getCartData, [this]) || this.context.cart;
        this.context.transaction = Utils.tryFunction(this.core.getOrderInfo, [this]) || this.context.transaction;
        this.context.custom = Utils.tryFunction(this.core.getCustomData, [this], null);
        this.context.categories = Utils.tryFunction(this.core.getCategoryPath, [this.context.categories]) || this.context.categories;
        this.context.sponsorId = Utils.tryFunction(this.core.getSponsorId, [null]) || this.context.sponsorId;
        setInterval(() => this.updateCart(), 2000);
        Utils.tryFunction(this.postTreatment, [null], null);
    };

    postTreatment = () => {
        if (this.context.product) {
            delete (this.context.alternate_image_url);
            if (this.context.product.description && this.context.product.description.length > 150) {
                this.context.product.description = this.context.product.description.substring(0, 150);
            }
            if (this.context.categories) {
                this.context.product.category = this.context.categories;
            } else {
                this.context.categories = this.context.product.category;
            }
        }
        if (this.context.customer.email || this.context.customer.customer_reference) {
            localStorage.setItem(Constants.emailStorageKey, this.context.customer.email);
            if (this.context.customer.email) {
                localStorage.setItem(Constants.customerStorageKey, JSON.stringify(this.context.customer));
            } else {
                this.context.customer.email = localStorage.getItem(Constants.emailStorageKey);
            }
        } else {
            if (localStorage.getItem(Constants.customerStorageKey)) {
                this.context.customer = JSON.parse(localStorage.getItem(Constants.customerStorageKey));
            }
            this.context.customer.email = localStorage.getItem(Constants.emailStorageKey);
        }

        if (!this.core.disablePersistentCart) {
            if ((this.context.cart && JSON.stringify(this.context.cart) !== '{}')
                || this.context.page_type === Constants.PAGE_TYPE.CART) {
                localStorage.setItem(Constants.cartStorageKey, JSON.stringify(this.context.cart));
            } else {
                this.context.cart = localStorage.getItem(Constants.cartStorageKey)
                    ? JSON.parse(localStorage.getItem(Constants.cartStorageKey))
                    : {total: 0};
            }

            if (this.context.cart && this.context.cart.total
                && this.context.cart.items.length && !this.context.cart.count) {
                let total = 0;
                this.context.cart.items.forEach(c => {
                    total += c.quantity;
                })
                this.context.cart.count = total;
            }
        }

        if (!this.context.campaigns || JSON.stringify(this.context.campaigns) === '{}') {
            this.context.campaigns = localStorage.getItem(Constants.campaignsStorageKey)
                ? JSON.parse(localStorage.getItem(Constants.campaignsStorageKey))
                : {};
        }

        if (this.context.sponsorId) {
            Utils.createCookie('cibler_sponsor', this.context.sponsorId, 365);
        }
    };


    getSponsorId = () => Utils.getQueryString('s');

    geoInfo = () => {
        const abinfos = sessionStorage.getItem(Constants.geolocStorage1);
        if (abinfos) {
            return JSON.parse(abinfos);
        }
        const infos = sessionStorage.getItem(Constants.geolocStorage2);
        if (infos) {
            return JSON.parse(infos);
        }

        return '';
    };

    device = () => Utils.getDevice();

    getOS = () => {
        /**
         * Determine the mobile operating system.
         * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
         *
         * @returns {String}
         */
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        var platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
          macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
          windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
          iosPlatforms = ['iPhone', 'iPad', 'iPod'],
          os = 'unknown';

        if (platform.toLowerCase().indexOf('mac') !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (/Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    }

    geolocation = () => {
        const info = this.geoInfo();
        if (info) {
            return `${info.latitude};${info.longitude}`;
        }
        return '0;0';
    };

    product = () => {
        if (!window.dataLayer) return {};
        let itemdata = window.dataLayer.find(p => p.event && (p.event === 'view_item'))
        if (itemdata && itemdata.ecommerce && itemdata.ecommerce.items && itemdata.ecommerce.items[0]) {
            let item = itemdata.ecommerce.items[0]
            return {
                url: window.location.href.split("?")[0],
                productId: item.item_id,
                productEAN: item.item_id,
                name: item.item_name,
                price: parseFloat(item.price),
                discount: parseFloat(item.discount),
                priceCurrencyCode: item.currency || 'EUR',
                availability: item.quantity > 0,
                category: item.category,
                category2: item.category2,
                category3: item.category3,
                category4: item.category4,
                category5: item.category5,
                variant: item.item_variant,
                description: item.item_list_name,
                brand: item.item_brand,
            }
        }
        let data = window.dataLayer.find(p => p.ecommerce && p.ecommerce.impressions)
        if (data && data.impressions && data.impressions.length) {
            let p = data.impressions[0];
            if (p) {
                return {
                    url: window.location.href.split("?")[0],
                    productId: p.id,
                    productEAN: p.id,
                    name: p.name,
                    price: parseFloat(p.price),
                    priceCurrencyCode: data.currency || 'EUR',
                    category: p.category,
                    variant: p.variant,
                    description: p.list,
                    brand: p.brand,
                }
            }
        }
        let detail = window.dataLayer.find(p => p.ecommerce && p.ecommerce.detail)
        if (detail && detail.ecommerce.detail.products && detail.ecommerce.detail.products.length) {
            let p = detail.ecommerce.detail.products[0];
            if (p) {
                return {
                    url: window.location.href.split("?")[0],
                    productId: p.id,
                    productEAN: p.id,
                    name: p.name,
                    price: parseFloat(p.price),
                    priceCurrencyCode: detail.currency || 'EUR',
                    category: p.category,
                    variant: p.variant,
                    description: p.list,
                    brand: p.brand,
                }
            }
        }
        return {}
    }
    cart = () => {
        return {}
    }
    transaction = () => {
        return {}
    }
    categories = () => {
        return {}
    }
    source = () => {
        const origin = document.referrer;
        const source = {
            origin,
            source: 'direct',
            site: '',
            utmSource: Utils.getQueryString('utm_source') || '',
            utmCampaign: Utils.getQueryString('utm_campaign') || '',
        };

        if (origin) {
            const parseList = {
                social: ['facebook.', 'instagram.', 't.co', 'twitter.com', 'reddit.'],
                organic_search: ['.google.', '.bing.', '.qwant.', '.duckduckgo.', '.ecosia.', '.lilo.', '.quora.', '.startpage.', '.searx.', '.yandex.', '.ask.', 'search.creativecommons.'],
            };
            const keyList = Object.keys(parseList);

            for (let k = 0; k < keyList.length; k += 1) {
                const list = parseList[keyList[k]];
                for (let l = 0; l < list.length; l += 1) {
                    if (origin.includes && origin.includes(list[l])) {
                        source.source = keyList[k];
                        source.site = list[l];
                        break;
                    }
                }
            }

            if (Utils.getQueryString('gclid')) {
                source.source = 'paid_search';
                source.site = 'google';
            }

            if (Utils.getQueryString('fbclid')) {
                source.source = 'paid_search';
                source.site = 'facebook';
            }

            if (Utils.getQueryString('utm_source') && Utils.getQueryString('utm_medium') === 'cpc') {
                source.source = 'shopping';
                source.site = Utils.getQueryString('utm_source');
            }

            if (Utils.getQueryString('referer_id') && Utils.getQueryString('model_id')) {
                source.source = 'shopping';
                source.site = document.referrer.includes('google') ? 'google' : 'other';
            }

            if (!document.referrer || !document.referrer.includes || (document.referrer.includes(document.location.host) && source === 'direct')) {
                source.source = '';
            }
        }

        return source;
    };

    updateCart = () => {
        this.context.cart = Utils.tryFunction(this.core.getCartData, [this]) || this.context.cart;
        Utils.tryFunction(this.postTreatment, [null], null);
    };

    /** getters * */
    getPageType = () => this.context.page_type;

    getTransaction = () => this.context.transaction;

    getDevice = () => this.context.device;

    getCustomer = () => this.context.customer;

    setTrackCampaign = (campaign, action) => {
        if (this.context.campaigns[campaign]) {
            this.context.campaigns[campaign][action] = true;
        } else {
            this.context.campaigns[campaign] = {};
            this.context.campaigns[campaign][action] = true;
        }

        localStorage.setItem(Constants.campaignsStorageKey, JSON.stringify(this.context.campaigns));
    }
}
